import React from 'react';
import {
    basePath,
    nonStandardColors,
    standardColors,
} from "../../../../lib/constant";
import { Controller, useFormContext } from "react-hook-form";


function FrameColour({register}) {
    const { control } = useFormContext();

    return (
        <div className='grid grid-cols-3 xl:grid-cols-4 text-gray-700'>
            <Controller
            name="oxide_frame_colour"
            control={control}
            render={({ field }) => (
                <>
                    {standardColors.concat(nonStandardColors).map(({ code, bg }) => (
                        <div key={code} className="group">
                            <div
                                className={`relative flex flex-col items-center gap-4 w-fit p-4 ${
                                    field.value === code ? 'bg-[#555454]' : ''
                                }`}
                            >
                                <div
                                    className={`size-12`}
                                    style={{ background: bg }}
                                />
                                <p className={`text-xs text-center uppercase ${
                                    field.value === code ? 'text-white' : 'text-gray-600'
                                }`}>
                                    {code.replace("_", " ")}
                                </p>
                                <input
                                    className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer"
                                    type="radio"
                                    id={`oxide_frame_colour_${code}`}
                                    name={`oxide_frame_colour`}
                                    value={code}
                                    checked={field.value === code}
                                    onChange={(e) => field.onChange(e.target.value)}
                                />
                            </div>
                        </div>
                    ))}
                </>
            )}
        />
        </div>
    );
}

export default FrameColour;
